module.exports = __webpack_public_path__ + "static/media/bg-credit-approved.b45f013f.svg";